import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { HeadlineVariationCard } from './HeadlineVariationCard';
import { HeadlineOverlayVariation } from '@/store/videoFeatures/types/headline-overlay';
import { cn } from '@/lib/utils';

interface SortableHeadlineVariationCardProps {
  variation: HeadlineOverlayVariation;
  isActive?: boolean;
  isPrimary?: boolean;
  trafficPercentage: number;
  onEdit: (variation: HeadlineOverlayVariation) => void;
  onDelete: (variationId: string) => void;
  canDelete?: boolean;
}

export const SortableHeadlineVariationCard: React.FC<SortableHeadlineVariationCardProps> = ({
  variation,
  ...props
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: variation.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cn(
        isDragging && "opacity-50 z-50"
      )}
    >
      <HeadlineVariationCard
        variation={variation}
        {...props}
      />
    </div>
  );
};
